import './CurrencySymbol.scss';

import React, { memo } from 'react';

import { CURRENCY_SYMBOLS_MAP, EUR_COUNTRIES } from '../../shared/constants';
import { useAppSelector } from '../../shared/hooks';
import { CurrencyType } from '../../types/baseTypes';

// Define prop types for the component
interface CurrencySymbolProps {
  country?: string;
  currency?: CurrencyType;
  type?: 'string' | 'element';
}

const currencyPrefixSymbol = (
  country?: string,
  currency?: CurrencyType,
  type: 'string' | 'element' = 'element',
) => {
  if (currency) {
    const currencyIcon =
      CURRENCY_SYMBOLS_MAP[
        currency.toUpperCase() as keyof typeof CURRENCY_SYMBOLS_MAP
      ];

    switch (currency.toUpperCase()) {
      case 'INR':
        return type === 'string' ? (
          'inr'
        ) : (
          <span className="rupee-icon">{currencyIcon}</span>
        );
      case 'EUR':
        return type === 'string' ? (
          'eur'
        ) : (
          <span className="rupee-icon">{currencyIcon}</span>
        );
      default:
        return type === 'string' ? (
          'usd'
        ) : (
          <span className="rupee-icon">{currencyIcon}</span>
        );
    }
  }

  if (country && ['IN', 'INDIA'].includes(country.toUpperCase())) {
    return type === 'string' ? (
      'inr'
    ) : (
      <span className="rupee-icon">{CURRENCY_SYMBOLS_MAP.INR}</span>
    );
  }

  if (country && EUR_COUNTRIES.includes(country.toUpperCase())) {
    return type === 'string' ? (
      'eur'
    ) : (
      <span className="rupee-icon">{CURRENCY_SYMBOLS_MAP.EUR}</span>
    );
  }

  return type === 'string' ? (
    'usd'
  ) : (
    <span className="rupee-icon">{CURRENCY_SYMBOLS_MAP.USD}</span>
  );
};

const CurrencySymbol: React.FC<CurrencySymbolProps> = ({
  country,
  currency,
  type = 'element',
}) => {
  const userDetails = useAppSelector((state) => state.user);

  const getCurrencySymbol = () => {
    const countryCode = country
      ? country.toUpperCase()
      : userDetails?.country?.toUpperCase();

    return currencyPrefixSymbol(countryCode, currency, type);
  };

  return <>{getCurrencySymbol()}</>;
};

export default memo(CurrencySymbol);
